import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {DynFormData} from '../../domain/data';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import {FormDataService} from '../../services/form-data.service';
import {GlobalAppService} from '../../../core/commons/global-app.service';
import {ConfirmationService} from 'primeng/primeng';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/combineLatest';
import {MessageSeverity} from 'app/core/commons/message-severity';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-form-data-list',
    templateUrl: './form-data-list.component.html',
    styleUrls: ['./form-data-list.component.scss']
})
export class FormDataListComponent implements AfterViewInit {

    displayedColumns = ['referenceNumber', 'name', 'createdDate', 'lastUpdate', 'actions'];

    forms: Observable<DynFormData[]>;

    dataSource: MatTableDataSource<DynFormData> = new MatTableDataSource<DynFormData>();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    resultsLength = 0;

    formGroup: FormGroup;
    private reload = new BehaviorSubject<boolean>(false);

    constructor(private formDataService: FormDataService,
                private router: Router,
                private confirmationService: ConfirmationService,
                private fb: FormBuilder,
                private appService: GlobalAppService) {
        this.formGroup = this.fb.group({
            referencia: new FormControl(''),
            nombre: new FormControl('')
        });
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.reload
            .switchMap(() => this.formDataService.getUserFormsCompleted())
            .do(() => this.appService.setLoading(true))
            .subscribe(data => {
                this.dataSource.data = data;
                this.resultsLength = data.length;
                this.appService.setLoading(false)
            }, err => {
                this.appService.setLoading(false);
                this.appService.sendMsg(
                    MessageSeverity.ERROR,
                    'No ha sido posible obtener los datos',
                    'Compruebe su conexión a internet, o comuníquese con el soporte')
            });

        this.reload.next(true);
    }

    ngOnInit() {
        this.dataSource.filterPredicate = (data: DynFormData, filter: string) => {
            let filterParse = JSON.parse(filter);
            let form = data.getForm()
            if (filterParse.referencia != '' && filterParse.nombre != '') {
                return form.id == filterParse.referencia &&
                    form.name.toLowerCase().includes(filterParse.nombre.toLowerCase());
            }
            if (filterParse.referencia != '') return form.referenceNumber == filterParse.referencia;
            if (filterParse.nombre != '') return form.name.toLowerCase().includes(filterParse.nombre.toLowerCase());
            return true
        };
    }

    applyFilter() {
        let filters = {
            nombre: this.formGroup.controls['nombre'].value,
            referencia: this.formGroup.controls['referencia'].value,
        };
        this.dataSource.filter = JSON.stringify(filters);
    }

    download(formData: DynFormData) {
        this.formDataService.downloadAsPdf(formData.id)
            .subscribe(res => {
                const fileURL = URL.createObjectURL(res);
                const downloadLink = document.createElement('a');
                downloadLink.href = fileURL;
                downloadLink.download = (formData as any).form.name + '_' +
                    new Date(formData.getCreatedDate()).toLocaleDateString() + '_' +
                    formData.getId() + '.pdf';
                downloadLink.click();
            })
    }

    navigateToEdit(formData: DynFormData) {
        this.router.navigate(['home', 'forms', 'data', formData.id]);
    }

    navigateToView(formData: DynFormData) {
        this.router.navigate(['home', 'forms', 'data', formData.id, 'view'])
    }

    deleteFormData(formData: DynFormData) {
        this.confirmationService.confirm({
            message: '¿Está seguro que desea eliminar el dictamen? Esta operación es irreversible.',
            icon: 'fa ui-icon-delete-forever',
            accept: () => {
                this.formDataService.delete(formData)
                    .subscribe(() => {
                        this.reload.next(true);
                        this.appService.sendMsg(
                            MessageSeverity.SUCCESS,
                            'Eliminado',
                            'Se ha eliminado el dictamen.')
                    }, error => {
                        this.appService.sendMsg(
                            MessageSeverity.ERROR,
                            'Error',
                            'No ha sido posible eliminar el dictamen. ' + error.json().message)
                    });
            }
        });
        this.formDataService.delete(formData.id)
    }

    isClearIconNameVisible(): boolean {
        return this.formGroup.controls['nombre'].value != '';
    }

    clearInputName() {
        this.formGroup.patchValue({
            nombre: ''
        });
    }

    isClearIconReferenciaVisible(): boolean {
        return this.formGroup.controls['referencia'].value != '';
    }

    clearInputReferencia() {
        this.formGroup.patchValue({
            referencia: ''
        });
    }

    clearFilter() {
        this.formGroup.patchValue({
            nombre: '',
            referencia: '',
        });
        this.applyFilter();
    }

    isDataToClear() {
        if (
            this.formGroup.controls['nombre'].value != '' ||
            this.formGroup.controls['referencia'].value != ''
        ) return true;
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/components/form-data-list/form-data-list.component.ts